import { useEffect, useRef, useState } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { ProgressSpinner } from 'primereact/progressspinner';
import { getPantallasNoRol, getPermisosPan } from '../../services/Roles/RolesService';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Checkbox } from 'primereact/checkbox';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';

const AdicionPantalla = ({ rol, onAdiciona }) => {
    const [pantalla, setPantalla] = useState();
    const [lstPantallas, setLstPantallas] = useState([]);
    const [cargaPantallas, setCargaPantallas] = useState(false);

    const [permiso, setPermiso] = useState();
    const [lstPermisos, setLstPermisos] = useState([]);
    const [cargaPermisos, setCargaPermisos] = useState(false);

    const [permisoSelec, setPermisoSelec] = useState([]);

    const adiToast = useRef();

    // Extrae la lista de bloques declarados en el parametro JSON de una pantalla.
    const extraerBloques = (parametroStr) => {
        if (!parametroStr) return [];
        try {
            const match = parametroStr.match(/"bloques"\s*:\s*"([^"]*)"/);
            if (!match) return [];
            return match[1].split(';').map(s => s.trim()).filter(Boolean);
        } catch (e) {
            return [];
        }
    };

    // Permisos aplicables a la pantalla seleccionada:
    //   - Si la pantalla no declara bloques -> mostramos todos los permisos no tipo BLOQUE_*
    //     (los BLOQUE_* solo tienen sentido cuando la pantalla los declara).
    //   - Si declara bloques -> mostramos no-BLOQUE_* y los BLOQUE_* declarados.
    const bloquesPantalla = pantalla ? extraerBloques(pantalla.parametro) : [];
    const permisosFiltrados = lstPermisos.filter(p => {
        const nombre = p.nombre || '';
        const esBloque = nombre.startsWith('BLOQUE_');
        if (!esBloque) return true;
        return bloquesPantalla.includes(nombre);
    });

    useEffect(() => {
        const cargaPantallas = async () => {
            try {
                setCargaPantallas(true);
                const pantallasRol = await getPantallasNoRol(rol.configuracionDetId);
                //console.log('DD00=', pantallasRol);
                setLstPantallas(pantallasRol);
            } catch (err) {
                console.error('Error: no se condiguen las Pantallas');
            } finally {
                setCargaPantallas(false);
            }
        };
        cargaPantallas();
    }, []);

    useEffect(() => {
        const cargaPermisos = async () => {
            try {
                setCargaPermisos(true);
                const permisosPan = await getPermisosPan();
                //console.log('FF00=', permisosPan)
                setLstPermisos(permisosPan);
            } catch (err) {
                console.error('Error: no se condiguen las Permisos');
            } finally {
                setCargaPermisos(false);
            }
        };
        cargaPermisos();
    }, []);

    const handleSelectCheck = (checked, fila) => {
        let nuevosSelec = [...permisoSelec];
        if (checked) {
            nuevosSelec.push(fila);
        } else {
            nuevosSelec = nuevosSelec.filter((item) => item.configuracionDetId !== fila.configuracionDetId);
        }
        setPermisoSelec(nuevosSelec);
    };

    const templateCheckbox = (fila) => {
        return <Checkbox checked={permisoSelec.some((item) => item.configuracionDetId === fila.configuracionDetId)} onChange={(evt) => handleSelectCheck(evt.checked, fila)} />;
    };

    const handleSelecTodos = (checked) => {
        if (checked) {
            setPermisoSelec([...permisosFiltrados]);
        } else {
            setPermisoSelec([]);
        }
    };

    const templateCabeceraChekbox = () => {
        const todosSel = permisosFiltrados.length > 0 && permisoSelec.length === permisosFiltrados.length;
        return <Checkbox checked={todosSel} onChange={(evt) => handleSelecTodos(evt.checked)} />;
    };

    const handleGuardaPer = () => {
        if (!pantalla) {
            adiToast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Debe Seleccionar una Pantalla', life: 3000 });
            return;
        }

        let lstPermisos = [];
        if (permisoSelec) {
            lstPermisos = permisoSelec.map((item) => item.configuracionDetId);
        }

        const dataAdicion = {
            pantallaId: pantalla.configuracionDetId,
            listaPermisos: lstPermisos
        };

        onAdiciona(dataAdicion);
    };

    return (
        <div className="card">
            <h5>Adición de una pantalla</h5>
            <Toast ref={adiToast} />
            <div className="formgrid grid p-fluid mb-3">
                {/* Combo de Pantallas */}
                <div className="field col-12 md:col-6">
                    {cargaPantallas ? (
                        <div className="flex align-items-center">
                            <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" />
                        </div>
                    ) : (
                        <Dropdown id="cboPantallas" value={pantalla} onChange={(e) => setPantalla(e.value)} options={lstPantallas} placeholder="Selecciona una Pantalla" optionLabel="nombre" filter showClear />
                    )}
                </div>
                {/* DataTable de Permisos */}
                <div className="field col-12 md:col-6">
                    {cargaPermisos ? (
                        <div className="flex align-items-center">
                            <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" />
                        </div>
                    ) : (
                        <DataTable value={permisosFiltrados} tableStyle={{ minWidth: '15rem' }} selectionMode="checkbox" selection={permisoSelec} onSelectionChange={(evt) => setPermisoSelec(evt.value)} dataKey="configuracionDetId">
                            <Column header={templateCabeceraChekbox} body={templateCheckbox} style={{ width: '3rem' }} />
                            <Column header="Permisos" field="nombre" />
                        </DataTable>
                    )}
                </div>
                <div className="field col-12 md:col-4">
                    <span> </span>
                </div>
                <div className="field col-12 md:col-4">
                    <Button label="Guardar" onClick={handleGuardaPer} />
                </div>
                <div className="field col-12 md:col-4">
                    <span> </span>
                </div>
            </div>
        </div>
    );
};

export default AdicionPantalla;
